import { useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Footer } from "../../../components/Landing/Footer";
import { Table, Button, Modal } from "antd";
import { ReactComponent as EyeIcon } from "../../../assets/eye-detail.svg";
import Inversion from "../../../assets/comunas/Mapa-de-Medellin-Cifras_Convocatorias---movil-vertical.jpg"
import mapaCifras from "../../../assets/comunas/mapaCifras.png"

export const Beneficiarios = () => {

  return (
    <>
      <Header />
      <HeaderScc />
      <div className="container-fluid2">
        <div className="row">
          <br />
        </div>
        <div className="justify-content-center">
          <div className="container-titles-information-component">
            <span className="pb-3 font-size-30px font-family-Montserrat-Semi  Bold">
              ¡Gracias a las convocatorias lo hacemos posible!
            </span>
          </div>
        </div>
        <div className="justify-content-center">
          <div id="mapContainer">
            <img src={mapaCifras} style={{maxWidth: '100%'}} alt="Inversion comunas"></img>
          </div>
          <div id="mapContainerMovil">
            <img src={Inversion} style={{maxWidth: '100%'}} alt="inversion comunas"></img>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
